import { useEffect, useState } from "react";

// Desain HP (kanvas "HoonStore Desain HP", Gaya B): hanya di layar < 768 px (batas `md` Tailwind yang dipakai halaman lain).
// Layar komputer tetap memakai tampilan lama.
const KUERI = "(max-width: 767px)";

// Selama cetak, lebar halaman = lebar kertas A4 (> 767 px), jadi kueri ini berubah walau layarnya HP. tahanSaatCetak = perubahan itu diabaikan,
// untuk halaman yang punya dokumen cetak sendiri (invoice): kalau diikuti, dokumen dibuat ulang tepat saat dicetak dan logo gambar belum sempat
// tampil di kertas. Halaman lain tetap mengikuti, karena cetak lewat menu peramban di HP selama ini menghasilkan tampilan komputer.
const sedangCetak = () => window.matchMedia("print").matches;

const cocok = () => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(KUERI).matches;

export function useHp({ tahanSaatCetak = false } = {}) {
  const [hp, setHp] = useState(cocok);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const m = window.matchMedia(KUERI);
    const ubah = () => { if (!(tahanSaatCetak && sedangCetak())) setHp(m.matches); };
    ubah();
    m.addEventListener ? m.addEventListener("change", ubah) : m.addListener(ubah);
    return () => { m.removeEventListener ? m.removeEventListener("change", ubah) : m.removeListener(ubah); };
  }, [tahanSaatCetak]);
  return hp;
}
